import React from "react";
import cl from "./UserData.module.css";
import axios from "axios";
import api from "../../api";
import LoadingWrapper from "../../components/Loading/LoadingWrapper";
import { OrbitProgress } from "react-loading-indicators";
import { accessGlobalUserState } from "../../stores/user";

export const UserData = () => {
  const [phone, setPhone] = React.useState("");
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [totalSpent, setTotalSpent] = React.useState(0);

  const SKIP_KEYS = [
    "birthdate",
    "gender",
    "email",
    "instagram",
    "discount",
    "photo",
    "kr_user_modal_status",
    "agent_working_hours",
  ];

  const SKIP_CAMPAIGN_KEYS = [
    "id",
    "updatedAt",
    "status",
    "end_time",
    "disabled",
    "createdAt",
  ];

  const campaignMapKeys = {
    campaign_type: "Тип продвижения",
    listing_id: "ID объявления",
    start_time: "Дата начала",
    paid: "Оплачено",
  };

  const userMapKeys = {
    id: "ID пользователя",
    phone: "Телефон",
    lastname: "Фамилия",
    firstname: "Имя",
    deleted: "Удален",
    user_type: "Тип пользователя",
    kr_name: "Имя на Крыше",
    kr_user_id: "ID пользователя на Крыше",
    kr_agency_id: "ID агентства на Крыше",
    kr_agency_name: "Название агентства на Крыше",
    kr_listing_type: "Тип объявления на Крыше",
    referred_by: "Реферал от ",
    is_blocked: "Заблокирован",
    iin: "ИИН",
    agent_full_address: "Адрес агента",
    agent_working_hours: "Рабочие часы агента",
    agent_city: "Город агента",
    agent_about: "Описание агента",
    agency_verification_status: "Статус верификации агентства",
    createdAt: "Дата создания",
    updatedAt: "Дата обновления",
  };

  const renderValue = (value) => {
    // if type date render date '2024-11-22T08:47:19.891Z'
    if (typeof value === "string" && value.includes("Z")) {
      return new Date(value).toLocaleString();
    }
    const campaign_types = {
      standart: "Silver",
      top: "Gold",
      button: "Button",
      platinum: "Platinum",
    };

    if (campaign_types[value]) {
      return campaign_types[value];
    }

    return value;
  };
  const user = accessGlobalUserState().get();
  const onSearch = async () => {
    setLoading(true);
    const req = await axios.get(
      `${api.serverUrl}/admin/user-data-by-phone/${phone}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    console.log(req);
    setData(req.data);
    setLoading(false);
  };

  return (
    <div className={cl.wrapper}>
      <div className={cl.container}>
        <form className={cl.input} onSubmit={(e) => e.preventDefault()}>
          <input
            type='phone'
            value={phone}
            placeholder='77077070'
            maxLength={13}
            onChange={(e) => setPhone(e.target.value)}
          />
          <div className={cl.submit}>
            <button onClick={onSearch}>Поиск</button>
          </div>
        </form>

        {data ? (
          <>
            <div className={cl.title}>Данные о пользователе</div>
            <div className={cl["user-data"]}>
              {data && (
                <div className={cl["user-data-item"]}>
                  <div className={cl.key}>Баланс пользователя</div>
                  <div className={[cl.value, cl.value__icon].join(" ")}>
                    {data?.bonusData?.count
                      ? data?.bonusData?.count
                      : "Нет данных"}
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      height='20px'
                      width='20px'
                      version='1.1'
                      id='_x32_'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                    >
                      <g>
                        <path
                          class='st0'
                          d='M490.102,239.149c-53.091-32.945-116.212-16.917-165.554-28.304c-33.238-7.672-73.804-24.264-107.686-25.02   c-16.714-0.37-52.765-18.763-58.299-30.41c-15.735-33.13-38.379-40.884-38.379-40.884c-20.146-21.395-43.439-6.472-46.089-4.648   c-2.654,1.809-4.304-0.015-12.002,0.222c-7.699,0.222-10.278,8.644-16.732,11.55c-6.45,2.898-18.464-0.593-24.972,0.874   c-12.002,2.721-16.691,9.667-19.034,18.444C0.704,143.428,0,150.909,0,150.909c1.709,0.83,4.64,1.594,8.347,2.076   c1.049,3.128,3.266,8.362,7.062,11.343c0,0,2.138,0.77,1.835-1.75c-0.197-1.646-0.09-6.138,0.014-9.089   c1.598-0.014,3.25-0.089,4.952-0.222c1.038,2.328,2.602,4.99,4.811,6.732c0,0,1.779,0.637,1.527-1.468   c-0.134-1.112-0.1-3.788-0.037-6.064c1.583-0.282,3.181-0.616,4.789-1.023c1.03,2.136,2.487,4.433,4.463,5.975   c0,0,1.779,0.638,1.527-1.453c-0.134-1.097-0.1-3.721-0.037-5.975c1.627-0.297,3.228-0.49,4.77-0.593   c0.993,1.868,2.313,3.751,4.014,5.085c0,0,1.78,0.638,1.524-1.453c-0.086-0.712-0.1-2.091-0.082-3.581   c4.1,0.37,7.358,1.498,8.959,3.106c5.619,5.642,7.51,9.696,7.421,13.588c-0.045,1.987-1.972,5.123-4.022,7.858   c-0.852-1.09-1.624-2.12-1.961-2.691c-0.976-1.661-1.909-0.222-1.909-0.222c-0.593,2.291-0.352,4.848,0.108,7.013   c-1.183,0.994-2.795,2.254-4.645,3.648c-1.334-1.646-2.943-3.692-3.484-4.604c-0.972-1.652-1.905-0.215-1.905-0.215   c-0.738,2.84-0.189,6.079,0.471,8.474c-1.101,0.801-2.221,1.609-3.358,2.424c-1.404-1.728-3.51-4.352-4.14-5.427   c-0.975-1.66-1.909-0.215-1.909-0.215c-0.834,3.21-0.026,6.946,0.73,9.378c-0.964,0.668-1.894,1.304-2.798,1.912   c-1.346-1.631-3.918-4.804-4.63-6.02c-0.971-1.646-1.909-0.207-1.909-0.207c-0.897,3.462,0.115,7.532,0.908,9.912   c-0.919,0.571-1.709,1.038-2.242,1.312c-4.949,2.52,8.911,10.839,14.782,11.12c5.872,0.282,21.414-11.268,28.63-11.654   c11.921-0.638,22.214,0.549,30.495,16.28c3.888,7.384,3.091,16.546,15.675,37.526c1.602,9.712,6.132,39.602,1.602,42.441   c-5.416,3.388-26.851,9.282-32.497,10.304c-5.641,1.016-11.168,8.252-11.783,14.286c2.769,1.408,7.28-1.416,7.28-1.416   s0.971,12.58,4.918,8.858c3.948-3.736,5.524-7.235,5.524-7.235s0.878,7.547,3.754,5.122c2.873-2.431,4.5-12.877,4.5-12.877   s38.067-5.545,42.69-12.217c1.504-2.165,2.728-7.095,3.603-12.81c12.444,8.97,29.16,17.48,47.953,23.892   c0.014,2.224,0.226,4.16,0.708,5.612c3.013,9.029,18.074,33.879,16.565,40.654c-1.506,6.776-15.057,24.094-23.341,24.85   c-8.281,0.749-15.057,5.271-15.809,9.029c-0.757,3.766-11.294,6.028-5.272,7.532c6.024,1.505,35.388,0.756,35.388,0.756   s-3.062,3.922,2.258,3.766c12.332-0.37,16.098-10.912,16.098-10.912s20.795-24.479,23.055-32.011   c1.553-5.182-3.317-25.361-6.994-39.394c13.203,1.616,26.596,1.853,39.617,0.326c9.096,6.746,19.474,12.544,30.624,15.732   c31.896,9.111,31.147,33.412,26.469,42.256c-8.221,2.142-19.375,5.73-18.656,9.326c0.611,3.069,3.903,2.795,7.317,2.269   c-3.758,4.611-7.102,9.815-8.355,13.158c-2.257,6.027,6.024-0.756,9.038,0c3.006,0.749,15.056-0.756,20.327-9.037   c0.749,0.756,2.262,11.298,2.262,11.298s-0.008,5.264,3.006,3.01c3.013-2.254,14.307-12.796,12.803-22.588   c-1.509-9.793,3.762-45.926-3.766-54.97c-4.652-5.575-18.489-16.042-30.343-28.548c0.204-0.141,0.427-0.26,0.634-0.408   c64.785-45.042,137.892-53.828,176.815-37.815C514.678,267.246,516.768,255.696,490.102,239.149z M8.773,138.173   c-1.241-0.978,0.464-6.754,2.628-7.332C13.562,130.255,10.887,139.833,8.773,138.173z M61.979,124.213   c-2.057,0.408-4.058-0.935-4.463-2.988c-0.048-0.237-0.067-0.474-0.067-0.711l6.364-2.803c0.571,0.519,0.994,1.216,1.153,2.039   C65.374,121.811,64.036,123.805,61.979,124.213z'
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              )}
              {data &&
                Object.keys(data?.userAccountData).map(
                  (key) =>
                    !SKIP_KEYS.includes(key) && (
                      <div key={key} className={cl["user-data-item"]}>
                        <div className={cl.key}>
                          {userMapKeys[key] ? userMapKeys[key] : key}
                        </div>
                        <div
                          className={cl.value}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 4,
                          }}
                        >
                          <div>
                            {data?.userAccountData[key]
                              ? data.userAccountData[key]
                              : "Нет данных"}
                          </div>
                        </div>
                      </div>
                    )
                )}

              <div className={cl["user-data-item"]}>
                <div className={cl.key}>Общий расход на продвижение</div>
                <div className={cl.value}>
                  {data?.campaignsData.reduce(
                    (acc, item) => acc + item.paid,
                    0
                  )}{" "}
                  ₸{" "}
                </div>
              </div>
              <div className={cl["user-data-item"]}>
                <div className={cl.key}>Общее кол-во объявлений</div>
                <div className={cl.value}>{data?.userListingData.length}</div>
              </div>
            </div>
            <div className={cl.title}>Данные о объявлениях</div>
            <div className={cl["user-data"]}>
              {data?.userListingData &&
                data?.userListingData.map((listing) => (
                  <div key={listing} className={cl["user-data-item"]}>
                    <div className={cl.key}>
                      {listing?.address_string} {listing?.price}
                    </div>
                    <div className={cl.value}>
                      <a
                        href={`https://kilt.kz/listings/${listing.id}`}
                        target='_blank'
                        className={cl.link}
                      >
                        id: {listing.id}
                      </a>
                    </div>
                  </div>
                ))}
            </div>

            <div className={cl.title}>Данные о продвижении</div>
            <div className={cl["user-data"]}>
              {data?.campaignsData &&
                data?.campaignsData.map((campaign, index) => {
                  return (
                    <div className={cl.comapign}>
                      {index + 1} {campaign?.campaign_type}
                      {Object.keys(campaign).map(
                        (key) =>
                          !SKIP_CAMPAIGN_KEYS.includes(key) && (
                            <div className={cl["user-data-item"]}>
                              <div className={cl.key}>
                                {campaignMapKeys[key]
                                  ? campaignMapKeys[key]
                                  : key}
                              </div>
                              <div className={cl.value}>
                                {key === "listing_id" ? (
                                  <a
                                    href={`https://kilt.kz/listings/${campaign[key]}`}
                                    target='_blank'
                                    className={cl.link}
                                  >
                                    {campaign[key]}
                                  </a>
                                ) : campaign[key] ? (
                                  renderValue(campaign[key])
                                ) : (
                                  "Нет данных"
                                )}
                              </div>
                            </div>
                          )
                      )}
                    </div>
                  );
                })}
            </div>
          </>
        ) : (
          <div className={cl.nothing}>
            {loading ? (
              <OrbitProgress color={"#1A278E"} size={24} />
            ) : (
              "Ничего не найдено"
            )}
          </div>
        )}
      </div>
    </div>
  );
};
